"use client";
import React from "react";

type NumericProps = {
  value?: number;
  unit?: string;
  precision?: number;
  showThousandsSeparator?: boolean;
  prefix?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const Numeric: React.FC<NumericProps> = ({
  value = "--",
  unit = "$", // 数字值
  precision = 2, // 小数位数
  showThousandsSeparator = false, // 是否显示千分位
  className = "", // 自定义类名
  style = {}, // 自定义内联样式
  prefix,
}) => {
  // 格式化数字（小数位数 + 千分位）
  const formatNumber = (num: any) => {
    if (num === "--") {
      return num;
    }

    let formatted = parseFloat(num).toFixed(precision);

    if (showThousandsSeparator) {
      formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // 为0时，不用加prefix='-'的前缀来表示负数
    if (prefix && !!num) {
      return prefix + unit + formatted;
    }

    return unit + formatted;
  };

  return (
    <span className={`number-display text-bravve-100 leading-22 ${className}`} style={style}>
      {formatNumber(value)}
    </span>
  );
};
